import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Container,
  Divider,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";

import {
  addPermissionFromRole,
  deletePermissionFromRole,
  getRolesById,
  updateRole,
} from "src/redux/actions/backOffice.action";
import _ from "lodash";

import PermissionModalComponent from "src/components/modals/PermissionModalComponent/PermissionModalComponent";
import Page from "src/components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    flexWrap: "wrap",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiFormControlLabel-root": {
      margin: theme.spacing(1),
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  remarkText: {
    borderLeft: 5,
    borderRight: 0,
    borderTop: 0.5,
    borderBottom: 0,
    borderStyle: "solid",
    borderColor: "grey",
    fontSize: 17,
    padding: (10, 20),
    margin: (0, 0, 20),
    fontStyle: "italic",
  },
  breadcrumbContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  formContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function RoleManagementEditSettingComponent() {
  const params = useParams();
  const classes = useStyles();
  const form = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [openPermissionModal, setOpenPermissionModal] = useState(false);

  const { role } = useSelector((state) => state.backOfficeReducer);

  useEffect(() => {
    dispatch(getRolesById(params.id));
    return () => {};
  }, [params.id]);

  return (
    <Page className={classes.root} title="Role Management (Role Edit Form)">
      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.goBack();
            }}
          >
            Role Management
          </Link>
          <Link color="textPrimary" aria-current="page">
            Role Edit Form
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the role management on the system."
            title="Role Management"
          />
          <Divider />
          <CardContent>
            <Box display="flex" flex={1} flexDirection="column">
              <Box>
                <Formik
                  ref={form}
                  enableReinitialize
                  initialValues={{
                    ...role.data,
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    setTimeout(() => {
                      dispatch(
                        updateRole(
                          params.id,
                          {
                            NAME: values.NAME,
                          },
                          history
                        )
                      );
                      resetForm({
                        value: "",
                      });

                      setSubmitting(false);
                    }, 500);
                  }}
                  validate={(values) => {
                    const errors = {};

                    if (!values.NAME) {
                      errors.NAME = "Required";
                    }

                    return errors;
                  }}
                >
                  {(formikProps) => {
                    const {
                      submitForm,
                      isSubmitting,
                      touched,
                      errors,
                      values,
                      setFieldValue,
                    } = formikProps;

                    return (
                      <Form noValidate>
                        <div>
                          <Box display="flex" flexDirection="column">
                            <Box display="flex">
                              <Field
                                component={TextField}
                                name="NAME"
                                label="Name"
                                style={{
                                  width: "100%",
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Box>
                            <Box display="flex" flexWrap="wrap">
                              {values.PERMISSIONs &&
                                values.PERMISSIONs.map((i, index) => (
                                  <>
                                    <Chip
                                      label={i.NAME}
                                      color="primary"
                                      clickable
                                      variant="outlined"
                                      style={{
                                        margin: 2,
                                      }}
                                      onDelete={(e) => {
                                        dispatch(
                                          deletePermissionFromRole(
                                            params.id,
                                            i.ID
                                          )
                                        );
                                      }}
                                    />{" "}
                                  </>
                                ))}
                            </Box>
                            <Box>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setOpenPermissionModal(true);
                                }}
                              >
                                Add Permission
                              </Button>
                            </Box>
                            <Box p={2} display="flex" justifyContent="flex-end">
                              <Box>
                                <Button
                                  color="primary"
                                  variant="contained"
                                  onClick={submitForm}
                                >
                                  <AddIcon />
                                  Save
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    history.goBack();
                                  }}
                                >
                                  Back
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                          <PermissionModalComponent
                            open={openPermissionModal}
                            handleClose={() => {
                              setOpenPermissionModal(false);
                            }}
                            handleAdd={(value) => {
                              let input = [];
                              value.map((i) => {
                                const validate = _.findIndex(
                                  values.PERMISSIONs,
                                  {
                                    ID: i.ID,
                                  }
                                );
                                if (validate === -1) {
                                  input.push({
                                    ROLE_ID: params.id,
                                    PERMISSION_ID: i.ID,
                                  });
                                }
                              });

                              if (input.length) {
                                dispatch(
                                  addPermissionFromRole(params.id, input)
                                );
                              }
                            }}
                          />
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
